import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserInfo } from '../user-info';
import { UserService } from './user.service';

@Injectable()
export class UserInfoResolver {
  private user = inject(UserService);
  private router = inject(Router);

  resolve(route: ActivatedRouteSnapshot): Observable<UserInfo> {
    const username = route.paramMap.get('username');
    return this.user.getProfile(username ? username : '').pipe(
      catchError((err) => {
        if (err.status === 404) {
          this.router.navigate(['404'], { skipLocationChange: true });
        }
        return of(null as UserInfo);
      })
    );
  }
}
